import script from "./TeacherLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./TeacherLayout.vue?vue&type=script&setup=true&lang=js"

import "./TeacherLayout.vue?vue&type=style&index=0&id=fa7039ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b5029c4e2822f65c6b0ae42e2fbfada5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa7039ba"]])

export default __exports__